import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import organizationService from "services/organizationService";
import authService from "services/authService";
import { Card } from "components/Card";
import Label from "components/Label/Label";
import Dropdown from "components/Dropdown/Dropdown";
import CurrentFilter from "components/CurrentFilter/CurrentFilter";
import InputComponent from "components/InputComponent/InputComponent";
import ButtonComponent from "components/ButtonComponent/ButtonComponent";
import UsersTable from "components/Tables/UsersTable";
import ListingTitle from "components/ListingTitle/ListingTitle";
import AddIcon from "@mui/icons-material/Add";
import ModalComponent from "components/ModalComponent/ModalComponent";
import { AddUserForm } from "components/Forms";
import Loader from "components/Loader";
import AlertComponent from "components/AlertComponent";

function OrganizationUser() {
  const [numericUser, setNumericUser] = useState([]);
  const [alphabeticUser, setAlphabeticUser] = useState([]);
  const [sortBy, setSortBy] = useState(0);
  const [userModal, setUserModal] = useState(false);
  const [organizationId, setOrganizationId] = useState(null);
  const [openLoaderModal, setOpenLoaderModal] = useState(false);
  const [enableSearchButton, setEnableSearchButton] = useState(true);
  const [searchInputField, setSearchInputField] = useState("");
  // const [searchItemArray, setSearchItemArrays] = useState({});
  const [searchItemArray, setSearchItemArrays] = useState([]);
  const [searchTitleData, setSearchTitleData] = useState([]);
  const [state, setState] = useState({
    emailAlertError: false,
    elailAlertSuccess: false,
    resetPosswordAlertError: false,
    resetPosswordAlertSuccess: false,
    lockUserAlertError: false,
    lockUserAlertSuccess: false,
    deleteUserAlertError: false,
    deleteUserAlertSuccess: false,
    addNewUserAlertSuccess: false,
    addNewUserAlertError: false,
    alertStatename: "",
    mesage: "",
    varient: "",
  });
  const isBlocked = false;
  const handleModal = (id) => {
    console.log("Clicked Add User for org ID:", id);
    setOrganizationId(id);
    setUserModal(true);
  };

  const getUsers = (customSort = null) => {
    let effectiveSort = null;

    // Only apply sort when explicitly requested
    if (customSort !== null) {
      effectiveSort = customSort;
    }

    if (effectiveSort !== null) {
      // Fetch sorted data (user selected Asc/Desc)
      authService.getAlphabeticalUser(effectiveSort).then((res) => {
        if (res.status === 200) {
          setAlphabeticUser(res.data);
        }
      });

      authService.getNumericUser(effectiveSort).then((res) => {
        if (res.status === 200) {
          setNumericUser(res.data);
        }
      });
    } else {
      // Fetch default unsorted data (initial load)
      authService.getAlphabeticalUser().then((res) => {
        if (res.status === 200) {
          setAlphabeticUser(res.data);
        }
      });

      authService.getNumericUser().then((res) => {
        if (res.status === 200) {
          setNumericUser(res.data);
        }
      });
    }
  };

  const openAlertModel = (statename, message, variant, alertstateName) => {
    setState((prev) => ({
      ...prev,
      [statename]: true,
      mesage: message,
      varient: variant,
      alertStatename: alertstateName,
    }));
  };
  const closeAlertModel = (statename) => {
    setState((prev) => ({
      ...prev,
      [statename]: false,
    }));
  };

  useEffect(() => {
    if (searchInputField) {
      setSearchTitleData([]);
      organizationService
        .handleSearchTitle(searchInputField)
        .then((res) => {
          setSearchTitleData(res.data.results);
        })
        .catch(() => {
          setSearchTitleData([]);
        });
    } else {
      setSearchTitleData([]);
    }
  }, [searchInputField]);

  const addNewUser = ({
    email,
    first_name,
    last_name,
    username,
    userImage,
  }) => {
    setOpenLoaderModal(true);
    authService
      .addNewUser({
        email,
        first_name,
        last_name,
        username,
        organizationId,
        userImage,
      })
      .then((res) => {
        if (res.status === 201) {
          setOpenLoaderModal(false);
          openAlertModel(
            "addNewUserAlertSuccess",
            "New user added successfuly!",
            "success",
            "addNewUserAlertSuccess"
          );
          getUsers();
          setUserModal(false);
        }
      })
      .catch(() => {
        openAlertModel(
          "addNewUserAlertError",
          "Error while adding new user. User with this email already exist!",
          "error",
          "addNewUserAlertError"
        );
        setOpenLoaderModal(false);
      });
  };
  const lockUser = (uId, val) => {
    authService
      .lockUser(uId, val)
      .then((res) => {
        if (res.status === 200) {
          getUsers();
        }
        openAlertModel(
          "lockUserAlertSuccess",
          "User Locked Successfuly",
          "success",
          "lockUserAlertSuccess"
        );
      })
      .catch(() => {
        openAlertModel(
          "lockUserAlertError",
          "Error while locking user!",
          "error",
          "lockUserAlertError"
        );
      });
  };
  const activateUser = (uId, val) => {
    authService
      .activateUser(uId, val)
      .then((res) => {
        if (res.status === 200) {
          getUsers();
        }
        openAlertModel(
          "lockUserAlertSuccess",
          "User activated successfuly",
          "success",
          "lockUserAlertSuccess"
        );
      })
      .catch(() => {
        openAlertModel(
          "lockUserAlertError",
          "Error while activating user!",
          "error",
          "lockUserAlertError"
        );
      });
  };
  const deleteUser = (id) => {
    authService
      .deleteUser(id)
      .then((res) => {
        if (res.status === 204) {
          getUsers();
        }
        openAlertModel(
          "deleteUserAlertSuccess",
          "User deleted successfuly!",
          "success",
          "deleteUserAlertSuccess"
        );
      })
      .catch(() => {
        openAlertModel(
          "deleteUserAlertError",
          "Error while deleting user!",
          "error",
          "deleteUserAlertError"
        );
      });
  };
  const editUser = ({ userId, first_name, last_name, type }) => {
    authService
      .updateUser(userId, { first_name, last_name, type })
      .then((res) => {
        if (res.status === 200) {
          getUsers();
        }
        openAlertModel(
          "addNewUserAlertSuccess",
          "User updated successfully!",
          "success",
          "addNewUserAlertSuccess"
        );
      })
      .catch(() => {
        openAlertModel(
          "addNewUserAlertError",
          "Error while updating user!",
          "error",
          "addNewUserAlertError"
        );
      });
  };

  const resetPassword = (id) => {
    authService
      .resetUserPassword(id)
      .then((res) => {
        if (res.status === 200) {
          getUsers();
        }
        openAlertModel(
          "resetPosswordAlertSuccess",
          "Password reset successfuly!",
          "success",
          "resetPosswordAlertSuccess"
        );
      })
      .catch(() => {
        openAlertModel(
          "resetPosswordAlertError",
          "Error while resetting password!",
          "error",
          "resetPosswordAlertError"
        );
      });
  };
  useEffect(() => {
    getUsers();
  }, []);
  const searchFilterApiData = () => {
    let filterTitles = "";
    searchItemArray.forEach((data) => {
      if (filterTitles === "") {
        filterTitles = `${data.item.title}`;
      } else {
        filterTitles = `${filterTitles},${data.item.title}`;
      }
    });
    const Filterdata = {
      sortBy: sortBy === 0 ? 1 : 0,
      filterTitles,
    };
    organizationService.filterAlphaOrganizationsUser(Filterdata).then((res) => {
      setAlphabeticUser(res.data);
    });
    organizationService
      .filterNumericOrganizationsUser(Filterdata)
      .then((res) => {
        setNumericUser(res.data);
      });
  };
  // const handleSortBtnFunction = (e) => {
  //   setSortBy(e.target.value);
  //   setEnableSearchButton(!searchItemArray.length);
  // };
  const handleSortBtnFunction = (eOrValue) => {
    const value = eOrValue?.target ? eOrValue.target.value : eOrValue;
    setSortBy(value);
    setEnableSearchButton(!searchItemArray.length);
    getUsers(value); // Pass the new sort value
  };
  const ClearItemTitleData = (data) => {
    if (data) {
      const afterClear = searchItemArray.filter((items) => {
        return items.item.id !== data.item.id;
      });
      setSearchItemArrays(afterClear);

      if (searchItemArray.length === 1) {
        setEnableSearchButton(true);
      }
    } else {
      getUsers();
      setSearchItemArrays([]);
      setEnableSearchButton(true);
    }
  };
  const handleSerachInputField = (e) => {
    setSearchInputField(e.target.value);
  };
  const handleSearchItemArray = (item) => {
    if (searchItemArray.length > 0) {
      const isExistItem = searchItemArray.some(
        (data) => data.item.id === item.id
      );
      setSearchTitleData([]);
      setSearchInputField("");
      if (!isExistItem) {
        setEnableSearchButton(false);
        setSearchItemArrays([...searchItemArray, { item }]);
      }
    } else {
      setSearchTitleData([]);
      setSearchInputField("");
      setEnableSearchButton(false);
      setSearchItemArrays([...searchItemArray, { item }]);
    }
  };
  let searchButtonClass = "search-organization-disable";
  if (!enableSearchButton) {
    searchButtonClass = "search-organization";
  }
  return (
    <div className="b-listing-container">
      {/* Loader */}
      <AlertComponent
        title={state.mesage}
        msg={state.varient}
        handleCloseAlert={() => closeAlertModel(state.alertStatename)}
        openAlert={state[state.alertStatename]}
      />
      <Loader title="Adding New User" openLoader={openLoaderModal} />
      <Grid container spacing={1}>
        <Grid item xs={12} md={4}>
          {/* Buttons */}
          <div className="b-filter-container">
            <ButtonComponent
              Icon={<SearchIcon className="tag-button-icon" />}
              cssName={searchButtonClass}
              title="Search For An Organization"
              enableSearchBtn={enableSearchButton}
              handleButtonClick={searchFilterApiData}
            />
            {/* Filter Card */}
            <Card
              title="Filter"
              bodyStyle="b-organization-container__headingBody"
              isLocked={false}
              body={
                <>
                  <Label label="Sort By" />
                  <Dropdown
                    cssName="user-dropdown"
                    setSortBy={handleSortBtnFunction}
                    sortBy={sortBy}
                  />
                  <CurrentFilter
                    filters={searchItemArray}
                    clearDataFun={ClearItemTitleData}
                  />
                  <InputComponent
                    onChange={handleSerachInputField}
                    searchInputField={searchInputField}
                    searchTitleData={searchTitleData}
                    setSearchItemArray={handleSearchItemArray}
                  />
                </>
              }
            />
          </div>
        </Grid>
        <Grid item xs={12} md={8}>
          <div className="b-listing-container__list-section">
            {/* Numerical Users */}
            {numericUser.length > 0 && (
              <>
                <ListingTitle
                  title="Numerical"
                  showIcon="false"
                  cssName="2px solid #005298"
                  fontColor="#005298"
                />
                {numericUser.map((nUser) => (
                  <Card
                    key={nUser.id}
                    title={nUser.title}
                    isLocked={false}
                    body={
                      <>
                        <UsersTable
                          users={nUser.userprofile_set}
                          HandleUserLock={lockUser}
                          HandleUserActivate={activateUser}
                          HandleUserDelete={deleteUser}
                          HandleUserPasswordReset={resetPassword}
                          HandleUserEdit={editUser}
                          openAlertModel={openAlertModel}
                        />
                        <ButtonComponent
                          Icon={<AddIcon className="tag-button-icon" />}
                          cssName="add-new-user"
                          title="Add New User"
                          handleButtonClick={() => handleModal(nUser.id)}
                          enableSearchBtn={false}
                        />
                      </>
                    }
                  />
                ))}
              </>
            )}
            {/* Alphabetical Users */}
            {alphabeticUser.length > 0 && (
              <>
                <ListingTitle
                  title="Alphabetic"
                  showIcon="false"
                  cssName="2px solid #005298"
                  fontColor="#005298"
                />
                {alphabeticUser.map((nUser) => {
                  return (
                    <Card
                      key={nUser.id}
                      title={nUser.title}
                      isLocked={false}
                      body={
                        <>
                          <UsersTable
                            users={nUser.userprofile_set}
                            HandleUserLock={lockUser}
                            HandleUserActivate={activateUser}
                            HandleUserDelete={deleteUser}
                            HandleUserPasswordReset={resetPassword}
                            HandleUserEdit={editUser}
                            openAlertModel={openAlertModel}
                          />
                          <ButtonComponent
                            Icon={<AddIcon className="tag-button-icon" />}
                            title="Add New User"
                            cssName="add-new-user"
                            handleButtonClick={() => handleModal(nUser.id)}
                            enableSearchBtn={false}
                          />
                        </>
                      }
                    />
                  );
                })}
              </>
            )}
          </div>
        </Grid>
      </Grid>
      {/* Add New User Modal */}
      <ModalComponent
        isLocked={isBlocked}
        title="Add New User"
        openModal={userModal}
        handleCloseModal={() => setUserModal(false)}
        // ModalBody={
        //   <AddUserForm handleResponse={addNewUser} orgId={organizationId} />
        // }
        ModalBody={
          organizationId ? (
            <AddUserForm handleResponse={addNewUser} orgId={organizationId} />
          ) : null
        }
      />
    </div>
  );
}

export default OrganizationUser;
